import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { Breadcrumb } from 'components/layout/Breadcrumb';
import { SocketProvider } from 'contexts/SocketContext';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { ASSETS_CACHE_KEY } from 'services/queryKeys';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';
import { DEVICE_TYPE_IDS } from 'utils/constants';

export const AssetsLayout = ({ routes }: { routes?: BreadcrumbsRoute[] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function onRowClick(params: { row: { deviceTypeId: number; externalIdentifier: string } }) {
    if (params.row.deviceTypeId === DEVICE_TYPE_IDS.REPORTING_ONLY_BATTERY) {
      return navigate(`${params.row.externalIdentifier}/reports`);
    }
    return navigate(`${params.row.externalIdentifier}`);
  }

  function onMarkerContentClick(externalIdentifier: string) {
    return navigate(`${externalIdentifier}`);
  }

  const { data: units } = useAxiosQuery(ASSETS_CACHE_KEY(), '/greener-units/');

  return (
    <>
      <SocketProvider>
        <Helmet>
          <title>{t('navigation.units')}</title>
        </Helmet>
        <Stack spacing={0}>
          {!!routes && <Breadcrumb routes={routes} />}
          <Outlet context={{ units, onMarkerContentClick, onRowClick }} />
        </Stack>
      </SocketProvider>
    </>
  );
};
